<div class="wizard-container p-6 w-full">
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>

  <!-- Breadcrumb / Back navigation -->
  <div class="mb-3">
    <p-button
      label="Torna al Registro"
      icon="pi pi-arrow-left"
      [outlined]="true"
      (onClick)="navigateToRegister()"
      [attr.aria-label]="'Torna al Registro Responsabili'"
      title="Torna al Registro Responsabili"
    ></p-button>
  </div>

  <!-- Page Header -->
  <section class="page-header mb-5" aria-labelledby="page-heading">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-users header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="page-heading">Inserimento Anagrafica Responsabile</h1>
          <p class="subtitle">Inserisci i dati anagrafici completi del nuovo responsabile</p>
        </div>
      </div>
    </div>
  </section>

  <form [formGroup]="responsibleForm" (ngSubmit)="submitForm()" class="p-fluid">
    <!-- Sezione Dati Responsabile -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-user text-2xl" style="color: #00125b" aria-hidden="true"></i>
        <h2 class="text-xl font-semibold m-0" style="color: #00125b">
          Dati Responsabile del Trattamento
        </h2>
      </div>

      <div class="grid">
        <div class="field col-12">
          <label for="businessName" class="font-semibold block mb-2">
            Ragione Sociale del Responsabile del Trattamento <span class="text-red-500">*</span>
          </label>
          <input
            pInputText
            id="businessName"
            formControlName="businessName"
            class="w-full"
            placeholder="Es: ANIA Safe"
            aria-required="true"
            aria-describedby="businessName-error"
          />
          <app-validation-error
            [control]="responsibleForm.get('businessName')"
            errorId="businessName-error"
            mode="strict"
            customMessage="Campo obbligatorio (minimo 3 caratteri)"
          />
          <small class="block mt-1 text-600">Non inserire il tipo di società</small>
        </div>

        <div class="field col-12 md:col-6">
          <label for="companyType" class="font-semibold block mb-2">
            Tipo societa <span class="text-red-500">*</span>
          </label>
          <p-select
            id="companyType"
            formControlName="companyType"
            [options]="companyTypeOptions"
            optionLabel="valueDescription"
            optionValue="valueKey"
            class="w-full"
            placeholder="Seleziona tipo societa"
            aria-required="true"
            aria-describedby="companyType-error"
          ></p-select>
          <app-validation-error
            [control]="responsibleForm.get('companyType')"
            errorId="companyType-error"
            mode="strict"
          />
        </div>

        <div class="field col-12 md:col-6">
          <label for="headquarters" class="font-semibold block mb-2">
            Sede del Responsabile del Trattamento <span class="text-red-500">*</span>
          </label>
          <input
            pInputText
            id="headquarters"
            formControlName="headquarters"
            class="w-full"
            placeholder="Es: Milano, Italia"
            aria-required="true"
            aria-describedby="sede-help headquarters-error"
          />
          <small id="sede-help" class="text-color-secondary">Formato: Città, Nazione</small>
          <app-validation-error
            [control]="responsibleForm.get('headquarters')"
            errorId="headquarters-error"
            mode="address"
          />
        </div>

        <div class="field col-12 md:col-6">
          <label for="mail" class="font-semibold block mb-2">
            Email <span class="text-red-500">*</span>
          </label>
          <input
            pInputText
            type="email"
            id="email"
            formControlName="email"
            class="w-full"
            placeholder="Es: responsabile@azienda.it"
            aria-required="true"
            aria-describedby="email-help email-error"
          />
          <small id="email-help" class="text-color-secondary"
            >Canale di comunicazione primario per contattare il responsabile</small
          >
          <app-validation-error
            [control]="responsibleForm.get('email')"
            errorId="email-error"
            mode="strict"
          />
        </div>
      </div>
    </section>

    <!-- Form Actions -->
    <div
      class="flex justify-content-end gap-3 mt-4"
      role="group"
      aria-label="Azioni form responsabile"
    >
      <p-button
        label="Annulla"
        [outlined]="true"
        (onClick)="navigateToRegister()"
        [disabled]="isLoading()"
        [attr.aria-label]="'Annulla e torna al registro'"
        title="Annulla e torna al registro"
      ></p-button>
      <p-button
        label="Salva"
        icon="pi pi-check"
        iconPos="right"
        severity="primary"
        type="submit"
        [loading]="isLoading()"
        [attr.aria-label]="'Salva responsabile'"
        title="Salva responsabile"
      ></p-button>
    </div>
  </form>
</div>
